import { Encoding } from "../types/types";
import base58 from "base-58";

export function hexToEncoding(hexKey: string, encoding: Encoding): string {
  if (!hexKey) return '';
  const bytes = Buffer.from(hexKey, 'hex');
  if (encoding === 'Hex') return hexKey;
  if (encoding === 'Base58') return base58.encode(bytes);
  if (encoding === 'Base64') return bytes.toString('base64');
  throw new Error('Unsupported encoding');
}

export function hexConverter(key: string, encoding: Encoding): string {
  if (!key.trim()) {
    throw new Error("Key is empty");
  }

  if (encoding === "Base58") {
    const base58Regex = /^[1-9A-HJ-NP-Za-km-z]+$/;

    if (!base58Regex.test(key)) {
      throw new Error("Invalid Base58 key");
    }

    console.log(Buffer.from(base58.decode(key)).toString("hex"))

    return Buffer.from(base58.decode(key)).toString("hex");
  }

  if (encoding === "Base64") {
    const normalized = key.replace(/\s/g, "");

    const isPureHex = /^[0-9a-fA-F]+$/.test(normalized);
    const isPureBase58 = /^[1-9A-HJ-NP-Za-km-z]+$/.test(normalized);
    if (isPureHex || isPureBase58) {
      throw new Error(
        "This is not a valid Base64 key"
      );
    }

    const base64Regex =
      /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
    if (!base64Regex.test(normalized)) {
      throw new Error("Invalid Base64 key");
    }

    return Buffer.from(normalized, "base64").toString("hex");
  }

  if (encoding === "Hex") {
    const hexRegex = /^(?:[0-9a-fA-F]{2})+$/;

    if (!hexRegex.test(key)) {
      throw new Error("Invalid Hex key");
    }

    return key.toLowerCase();
  }

  throw new Error("Unsupported encoding");
}
